import ErrorPage4 from '../Components/Pages/ErrorPages/ErrorPage404';
import Signin from '../Auth/Signin';

export const authRoutes = [
  { path: `/`, Component: <Signin /> },

  //Error
  { path: `/error-404`, Component: <ErrorPage4 /> },
];
